// download.ts — hand a level's JSON to the browser as a file.
//
// The object URL is revoked on the next tick rather than immediately: Firefox and Safari start the
// download asynchronously after the synthetic click, and revoking in the same frame has them save a
// zero-byte file. A single timeout is enough — the browser has taken its reference by then.
export function downloadText(fileName, text, mimeType = "application/json") {
    downloadBlob(fileName, new Blob([text], { type: mimeType }));
}
/** The same, for content that is not text — a level pack is a zip. */
export function downloadBlob(fileName, blob) {
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = fileName;
    // Appended to the document because a detached anchor's click is ignored in Firefox.
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 0);
}
/**
 * The file name a downloaded level gets: the level's own name, prefixed with the environment it came
 * from and which half it is.
 *
 * Without the prefix every environment's 0001.json lands in ~/Downloads as 0001.json, 0001(1).json,
 * 0001(2).json — and since a template and a compiled level share a name, the two halves collide with
 * each other too. Which of those a file is matters: one opens in the editor, the other is what the
 * game plays.
 */
export function levelFileName(environmentId, half, levelName) {
    const environment = (environmentId ?? "production").replace(/[\\/]/g, "-");
    const base = levelName.toLowerCase().endsWith(".json") ? levelName.slice(0, -5) : levelName;
    return `${environment}-${half}-${base}.json`;
}
